export default {
  badge: 'Skilt',
  open: 'Åpne',
  close: 'Lukk',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Avbryt',
  },
  dataIterator: {
    noResultsText: 'Fant ingen matchende elementer.',
    loadingText: 'Laster elementer...',
  },
  dataTable: {
    itemsPerPageText: 'Rader per side:',
    ariaLabel: {
      sortDescending: 'Sortert synkende.',
      sortAscending: 'Sortert stigende.',
      sortNone: 'Ikke sortert.',
      activateNone: 'Aktiver for å fjerne sortering.',
      activateDescending: 'Aktiver for å sortere synkende.',
      activateAscending: 'Aktiver for å sortere stigende.',
    },
    sortBy: 'Sorter etter',
  },
  dataFooter: {
    itemsPerPageText: 'Elementer per side:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Neste side',
    prevPage: 'Forrige side',
    firstPage: 'Første side',
    lastPage: 'Siste side',
    pageText: '{0}-{1} av {2}',
  },
  dateRangeInput: {
    divider: 'til',
  },
  datePicker: {
    itemsSelected: '{0} selected',
    range: {
      title: 'Velg datoer',
      header: 'Velg datoer',
    },
    title: 'Velg dato',
    header: 'Velg dato',
    input: {
      placeholder: 'Fyll inn dato',
    },
  },
  noDataText: 'Ingen data er tilgjengelig',
  carousel: {
    prev: 'Forrige bilde',
    next: 'Neste bilde',
    ariaLabel: {
      delimiter: 'Karusellbilde {0} av {1}',
    },
  },
  calendar: {
    moreEvents: '{0} flere',
    today: 'Today',
  },
  input: {
    clear: 'Fjern {0}',
    prependAction: '{0} prepended action',
    appendAction: '{0} appended action',
    otp: 'Please enter OTP character {0}',
  },
  fileInput: {
    counter: '{0} filer',
    counterSize: '{0} filer ({1} totalt)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Select Time',
  },
  pagination: {
    ariaLabel: {
      root: 'Paginasjonsnavigasjon',
      next: 'Neste side',
      previous: 'Forrige side',
      page: 'Gå til side {0}',
      currentPage: 'Gjeldende side, side {0}',
      first: 'Første side',
      last: 'Siste side',
    },
  },
  stepper: {
    next: 'Neste',
    prev: 'Forrige',
  },
  rating: {
    ariaLabel: {
      item: 'Anmeldelse {0} av {1}',
    },
  },
  loading: 'Laster...',
  infiniteScroll: {
    loadMore: 'Last flere',
    empty: 'Det var alt',
  },
}
